import { environment } from 'src/environments/environment';
import { Component, OnInit, Input } from '@angular/core';
import { PlatformType } from 'src/environments/platform-type.enum';

@Component({
  selector: 'app-icon-prepare-account',
  templateUrl: './icon-prepare-account.component.html',
  styleUrls: ['./icon-prepare-account.component.scss']
})
export class IconPrepareAccountComponent implements OnInit {
  @Input() cssClass = '';

  currentPlatform = environment.platformId;
  PlatformType = PlatformType;

  constructor() { }

  ngOnInit(): void {
  }

}
